import { get } from 'lodash'
import service from 'services/i18n'
import config from 'config/ui'
import {humanize} from 'utils/string'

/**
 * Ui class
 *
 * Loads and translates UI options from config
 */
const Ui = {

  /**
   * Get UI value(s) by path
   *
   * @param path
   * @returns {*}
   */
  get(path) {
    const value = get(config, path)
    if (value) {
      return value
    }
    return error(path, 'cannot be resolved')
  },

  /**
   * Get UI options for a dropdown / radio element by path
   *
   * @usage
   *
   *  const options = Ui.options('path.to.item') // [{label:'Foo Label', value:'foo'}, ...]
   *
   * @param {string}  path
   */
  getOptions (path) {
    const options = this.get(path)
    if (options) {
      if (Array.isArray(options)) {
        return options.map(option => {
          return {
            label: service.t(option.label).toLocaleString(),
            value: option.value
          }
        })
      }
      error(path, 'value is not an array')
      return []
    }
  },

  /**
   * Make UI options for a dropdown / radio element by array
   *
   * @param   {Array}   options
   * @param   {string}  initial
   * @returns {Array}
   */
  makeOptions (options, initial) {
    if (typeof path === 'string') {
      options = this.getOptions(options)
    }
    if (initial) {
      if (typeof initial === 'string') {
        return [{ value: initial, label: humanize(initial) }, ...options]
      }

      return [initial, ...options]
    }
    return options
  },

  /**
   * Get label for the passed UI options path and value
   *
   * @usage
   *
   *  const label = Ui.label('path.to.item', 'foo') // Foo Label
   *
   * @param path
   * @param value
   * @returns {string}
   */
  label(path, value) {
    const options = this.getOptions(path)
    if (options) {
      const option = options.find(option => option.value === value)
      if (option) {
        return option.label
      }
      error(path, `options do not contain an item with the value "${value}"`)
    }
    return '??'
  },

  /**
   * Get UI text
   *
   * @param path
   */
  text (path) {
    const value = this.get(path)
    if (value) {
      if (typeof value === 'string') {
        return service.t(value)
      }
      error(path, 'value is not a string')
      return ''
    }
  }
}

function error (path, message) {
  console.warn(`Ui error: path '${path}' ${message}`)
  return null
}

export default Ui
